/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S6_P1Inputs */

const tr_iade_iptal_s6_p1 = /** @type {(inputs: Iade_Iptal_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı'nın Abone'ye sunduğu Deneme Süresi süresince:`)
};

const en_iade_iptal_s6_p1 = /** @type {(inputs: Iade_Iptal_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`During the Trial Period offered by the Provider to the Subscriber:`)
};

const de_iade_iptal_s6_p1 = /** @type {(inputs: Iade_Iptal_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Während der vom Anbieter dem Abonnenten angebotenen Testphase gilt:`)
};

const ru_iade_iptal_s6_p1 = /** @type {(inputs: Iade_Iptal_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В течение Пробного периода, предоставленного Поставщиком Абоненту:`)
};

/**
* | output |
* | --- |
* | "During the Trial Period offered by the Provider to the Subscriber:" |
*
* @param {Iade_Iptal_S6_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s6_p1 = /** @type {((inputs?: Iade_Iptal_S6_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S6_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s6_p1(inputs)
	if (locale === "de") return de_iade_iptal_s6_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s6_p1(inputs)
	return tr_iade_iptal_s6_p1(inputs)
});